import { ErrorType } from 'constants/errors';
import { ErrorResponseType } from 'types/request';

const checkIsCaptchaFinalError = (error: ErrorResponseType) => {
  return error?.body?.key === ErrorType.CAPTCHA_FINAL_ERROR;
};

export default checkIsCaptchaFinalError;
